var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGmail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#F2F2F2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.186 2.944L19.654 18.329 1.252 18.329 0.018 3.242 10.453 9.084z",
    transform: "translate(1.547)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.667 0.046L10.453 9.64 0.24 0.046 10.453 0.046z",
    transform: "translate(1.547)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#F14336",
    d: "M2.799 4.476V18.33H1.132C.507 18.329 0 17.822 0 17.197V2.436l1.828.05.971 1.99z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D32E2A",
    d: "M24 2.436v14.761c0 .625-.507 1.132-1.132 1.132H21.2V4.476l.923-2.18 1.876.14z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F14336",
    d: "M24 1.178v1.258l-2.799 2.04L12 11.183 2.799 4.476 0 2.436V1.178C0 .553.507.046 1.132.046h.655L12 7.49 22.213.046h.655C23.493.046 24 .553 24 1.178z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D32E2A",
    d: "M2.799 4.476L0 4.042 0 2.436z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmail);
export default __webpack_public_path__ + "static/media/gmail.8d848dfc.svg";
export { ForwardRef as ReactComponent };